import { bootstrapApplication } from '@angular/platform-browser';
import { SwUpdate } from '@angular/service-worker';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { installAppUpdateControl } from './app-update-control';
import { installMusicAudioController } from './music-audio-controller';
import { installSpeechLoadingOverlay } from './speech-loading-overlay';

installSpeechLoadingOverlay();
installMusicAudioController();
bootstrapApplication(App, appConfig)
  .then((appRef) => installAppUpdateControl(appRef.injector.get(SwUpdate)))
  .catch((error: unknown) => console.error(error));
